// utils/useDeviceDetect.js
import React from 'react'

export default function useDeviceDetect() {
  const [isMobile, setMobile] = React.useState(false)

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent
    const screenWidth = window.innerWidth

    // Detect phones (exclude tablets)
    // Remove iPad from mobile detection - tablets should show desktop interface
    const isIPhone = /iphone|ipod/i.test(userAgent)

    // For Android, detect tablets by user agent patterns OR screen width >= 600px
    // User agent patterns help identify tablets even when browser dev tools simulate incorrect viewport sizes
    const isAndroid = /android/i.test(userAgent)
    const userAgentLower = userAgent.toLowerCase()
    const isAndroidTabletByUserAgent =
      isAndroid &&
      (/tablet/i.test(userAgentLower) ||
        /galaxy tab/i.test(userAgentLower) ||
        /tab s/i.test(userAgentLower) ||
        /nexus [789]|nexus 10/i.test(userAgentLower) ||
        /pixel c/i.test(userAgentLower) ||
        /xoom/i.test(userAgentLower) ||
        /transformer/i.test(userAgentLower) ||
        /playbook/i.test(userAgentLower) ||
        /kindle fire/i.test(userAgentLower) ||
        /silk/i.test(userAgentLower))
    const isAndroidTabletByWidth = isAndroid && screenWidth >= 600
    const isAndroidTablet = isAndroidTabletByUserAgent || isAndroidTabletByWidth
    const isAndroidPhone = isAndroid && !isAndroidTablet

    // Other mobile devices (BlackBerry, Opera Mini, IEMobile, WPDesktop)
    const isOtherMobile = Boolean(userAgent.match(/BlackBerry|Opera Mini|IEMobile|WPDesktop/i))

    // Only phones are considered mobile, not tablets
    const mobile = isIPhone || isAndroidPhone || isOtherMobile

    setMobile(mobile)
  }, [])

  return { isMobile }
}
